import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';
import TablePagination from '@material-ui/core/TablePagination';
import Empty from '../../components/common/Empty';
import Link from '../../components/common/Link';
import * as EventsActionCreators from '../../redux/events';
import * as UiActionsCreators from '../../redux/ui';
import {
  SHOWING_FIELDS_EVENTS,
  SORTABLE_FIELDS_EVENTS,
  ROWS_PER_PAGE
} from '../../constants';

const { REACT_APP_FRONTEND_URL } = process.env;

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const EventsTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const EventsTableHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const EventsTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;

const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

const SearchButton = styled(Button)`
  && {
    margin-left: 20px;
  }
`;

class EventsPage extends Component {
  state = {
    searchField: null,
    idField: null,
    order: 'desc',
    orderBy: 'created_at',
    showingPage: 0
  };

  componentDidMount() {
    this.clearSearchOrganization();
  }
  clearSearchOrganization = () => {
    const { actions } = this.props;
    this.setState({
      showingPage: 0,
      searchField: '',
      idField: '',
      order: 'desc',
      orderBy: 'created_at'
    });
    const { orderBy, order } = this.state;
    actions.getEvents(ROWS_PER_PAGE, 0, orderBy, order);
  };
  onClickSearchEvent = () => {
    const { actions } = this.props;
    const { orderBy, order, searchField, idField } = this.state;
    actions.getEvents(ROWS_PER_PAGE, 0, orderBy, order, searchField, idField);
  };

  onEnter = e => {
    if (e.key === 'Enter') {
      this.onClickSearchEvent();
    }
  };

  onClickSortHandle = orderBy => event => {
    const { actions } = this.props;
    const { showingPage } = this.state;
    const { searchField, idField } = this.state;
    const order = this.state.order === 'asc' ? 'desc' : 'asc';

    this.setState({ orderBy, order });

    actions.getEvents(
      ROWS_PER_PAGE,
      showingPage,
      orderBy,
      order,
      searchField,
      idField
    );
  };

  onChangeSearch = value => this.setState({ searchField: value });

  onChangeId = value => this.setState({ idField: value });

  getCellNames = () => {
    return [
      'real_id',
      'name',
      'organization_name',
      'display_at_home',
      'requires_approval',
      'private',
      'free_event',
      'start_date',
      'min_price',
      'created_at',
      'actions'
    ];
  };

  renderTableCellNames = () => {
    const cellNames = this.getCellNames();
    const { orderBy, order } = this.state;
    return cellNames.map((name, i) => {
      if (SHOWING_FIELDS_EVENTS.includes(name)) {
        const displayName = startCase(name);
        if (SORTABLE_FIELDS_EVENTS.includes(name)) {
          return (
            <EventsTableHeadFields key={i}>
              <TableSortLabel
                active={orderBy === name}
                direction={order}
                onClick={this.onClickSortHandle(name)}
              >
                {displayName}
              </TableSortLabel>
            </EventsTableHeadFields>
          );
        }

        return (
          <EventsTableHeadFields key={i}>{displayName}</EventsTableHeadFields>
        );
      }
      return null;
    });
  };

  renderTableBody = () => {
    const { events } = this.props;

    if (!events) return <TableRow />;
    const cellNames = this.getCellNames();
    return events.map((event, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            if (SHOWING_FIELDS_EVENTS.includes(field)) {
              if (field) {
                let value;
                if (field === 'created_at' || field === 'start_date') {
                  value = event[field]
                    ? moment(event[field]).format('LLLL')
                    : '-';
                } else if (field === 'min_price') {
                  value = event[field] === 0 ? 'free' : event[field];
                } else if (typeof event[field] === 'boolean') {
                  if (event[field]) {
                    value = (
                      <span style={{ color: 'green' }}>
                        {event[field].toString()}
                      </span>
                    );
                  } else {
                    value = (
                      <span style={{ color: 'red' }}>
                        {event[field].toString()}
                      </span>
                    );
                  }
                } else if (field === 'free_event') {
                  value = event['min_price'] === 0 ? 'Yes' : 'No';
                } else if (field === 'actions') {
                  return (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Link to={`/events/${event.id}/edit`}>
                          <Button variant="outlined" color="primary">
                            Edit
                          </Button>
                        </Link>
                      </EditButtonContainer>
                    </TableCell>
                  );
                } else if (field === 'name') {
                  const eventURL = [REACT_APP_FRONTEND_URL, event.id].join('/');
                  value = (
                    <div>
                      <a href={eventURL} target="_blank">
                        {event[field]}
                      </a>
                    </div>
                  );
                } else {
                  value = event[field];
                }
                return <TableCell key={index}>{value}</TableCell>;
              }
            }
            return null;
          })}
        </TableRow>
      );
    });
  };
  handleChangePage = (event, page) => {
    const { actions } = this.props;
    const { orderBy, order, searchField, idField } = this.state;
    actions.getEvents(
      ROWS_PER_PAGE,
      page,
      orderBy,
      order,
      searchField,
      idField
    );
    this.setState({
      showingPage: page
    });
  };
  renderTable = () => {
    const { ui, meta } = this.props;
    const { showingPage } = this.state;
    if (ui === 'complete') {
      return (
        <Fragment>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
          <EventsTable>
            <EventsTableHead>
              <TableRow>{this.renderTableCellNames()}</TableRow>
            </EventsTableHead>
            <TableBody>{this.renderTableBody()}</TableBody>
          </EventsTable>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
        </Fragment>
      );
    }

    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);

  render() {
    const { searchField, idField } = this.state;

    return (
      <div>
        <TextField
          id="search"
          label="Search by Event Name"
          type="search"
          margin="normal"
          onChange={e => this.onChangeSearch(e.target.value)}
          onKeyPress={this.onEnter}
          style={{ margin: 10, width: 200 }}
          value={searchField}
        />
        <TextField
          id="url"
          label="Search by URL"
          type="search"
          margin="normal"
          onChange={e => this.onChangeId(e.target.value)}
          onKeyPress={this.onEnter}
          style={{ margin: 10 }}
          value={idField}
        />
        <SearchButton
          variant="raised"
          onClick={() => this.clearSearchOrganization()}
        >
          Clear
        </SearchButton>
        <SearchButton
          variant="contained"
          color="primary"
          onClick={() => this.onClickSearchEvent()}
        >
          Search
        </SearchButton>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  events: state.events.events,
  ui: state.ui.uiState,
  meta: state.users.meta
});

const ActionCreators = Object.assign(
  {},
  EventsActionCreators,
  UiActionsCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsPage);



// WEBPACK FOOTER //
// ./src/pages/events/index.js